// Cap slider bounds in settings UI.
export const MIN_CAP_PERCENTAGE = 1
export const MAX_CAP_PERCENTAGE = 100

// Backend stores request deadline day (1..27). UI shows cycle closeout day (2..28).
// No wrap logic: closeout day is always the day after the request deadline.
const MIN_REQUEST_DEADLINE_DAY = 1
const MAX_REQUEST_DEADLINE_DAY = 27
export const MIN_CLOSEOUT_DAY = MIN_REQUEST_DEADLINE_DAY + 1
export const MAX_CLOSEOUT_DAY = MAX_REQUEST_DEADLINE_DAY + 1

export const toCloseoutDay = (requestDeadlineDay: number) => {
  return requestDeadlineDay + 1
}

export const toRequestDeadlineDay = (closeoutDay: number) => {
  return closeoutDay - 1
}

export const normalizeCapPercentage = (capPercentage: number) => {
  return Math.max(MIN_CAP_PERCENTAGE, Math.min(capPercentage, MAX_CAP_PERCENTAGE))
}

export const ACCRUAL_MODE_CALENDAR_ONLY = 'calendar_only'
export const ACCRUAL_MODE_ATTENDANCE_CONNECTED = 'attendance_connected'

export const ACCRUAL_MODES = [
  ACCRUAL_MODE_CALENDAR_ONLY,
  ACCRUAL_MODE_ATTENDANCE_CONNECTED,
] as const

export type AccrualMode = (typeof ACCRUAL_MODES)[number]

export const isAccrualMode = (value: string): value is AccrualMode => {
  return ACCRUAL_MODES.some((accrualMode) => accrualMode === value)
}
